

import {
  CREATE_ROLE_REQUEST,
  CREATE_ROLE_SUCCESS,
  CREATE_ROLE_FAILURE,
  CREATE_PERMISSION_REQUEST,
  CREATE_PERMISSION_SUCCESS,
  CREATE_PERMISSION_FAILURE,
  FETCH_ROLES_REQUEST,
  FETCH_ROLES_SUCCESS,
  FETCH_ROLES_FAILURE,
  FETCH_PERMISSIONS_REQUEST,
  FETCH_PERMISSIONS_SUCCESS,
  FETCH_PERMISSIONS_FAILURE,
  ASSIGN_ROLE_PERMISSION_REQUEST,
  ASSIGN_ROLE_PERMISSION_SUCCESS,
  ASSIGN_ROLE_PERMISSION_FAILURE,
  FETCH_ROLE_PERMISSIONS_REQUEST,
  FETCH_ROLE_PERMISSIONS_SUCCESS,
  FETCH_ROLE_PERMISSIONS_FAILURE,
} from "../actions/roleActions";

const initialState = {
  roles: [],
  permissions: [],
  rolePermissions: [],
  loading: false,
  error: null,
};

const roleReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_ROLE_REQUEST:
    case CREATE_PERMISSION_REQUEST:
    case FETCH_ROLES_REQUEST:
    case FETCH_PERMISSIONS_REQUEST:
    case ASSIGN_ROLE_PERMISSION_REQUEST:
    case FETCH_ROLE_PERMISSIONS_REQUEST:
      return { ...state, loading: true, error: null };

    case CREATE_ROLE_SUCCESS:
    case CREATE_PERMISSION_SUCCESS:
    case ASSIGN_ROLE_PERMISSION_SUCCESS:
      return { ...state, loading: false };

    case FETCH_ROLES_SUCCESS:
      return { ...state, loading: false, roles: action.payload };

    case FETCH_PERMISSIONS_SUCCESS:
      return { ...state, loading: false, permissions: action.payload };

    case FETCH_ROLE_PERMISSIONS_SUCCESS:
      return { ...state, loading: false, rolePermissions: action.payload };

    case CREATE_ROLE_FAILURE:
    case CREATE_PERMISSION_FAILURE:
    case FETCH_ROLES_FAILURE:
    case FETCH_PERMISSIONS_FAILURE:
    case ASSIGN_ROLE_PERMISSION_FAILURE:
    case FETCH_ROLE_PERMISSIONS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default roleReducer;
